/*
 * Laurie RS Theme
 *
 * Use this file to add custom Javascript to Laurie RS.  Keeping your custom
 * Javascript in this fill will make it easier to update Laurie RS. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  const searchBar = document.getElementById("searchMovmentBar");
  const accordionItems = document.querySelectorAll(".accordion__item");

  if (searchBar && accordionItems) {
    searchBar.addEventListener("keyup", (e) => {
      const searchText = e.target.value.toLowerCase();
      accordionItems.forEach((item) => {
        const titleText = item
          .querySelector(".accordion__item__title__text")
          .textContent.toLowerCase();
        if (titleText.includes(searchText)) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
    });
  }
  function checkVideo(videoElement) {
    const nextButton = videoElement.querySelector("button");
    const videoButton = videoElement.querySelector(".level__video-button");
    const tl = gsap.timeline();
    const image = videoElement.querySelector(".level__image");
    const video = videoElement.querySelector(".level__video");
    const title = videoElement.querySelector(".section__subheading");
    video.style.transitionDelay = "0s";
    videoElement.style.transitionDelay = "0s";
    image.style.transitionDelay = "0s";
    image.classList.remove("blur-sm");
    const isMobile = window.innerWidth < 768; // Détecte si l'appareil est un mobile
    const cols = isMobile ? "col-span-3" : "col-span-4";
    tl.to(title, { duration: 0.2, autoAlpha: 0 }, 0);
    title.classList.remove('title-active','animate-pulse');
    tl.to(nextButton, { duration: 0.2, scale: 0, autoAlpha: 0 }, ">");
    tl.to(video, { duration: 0.2, autoAlpha: 0 }, ">");
    tl.to(
      videoElement,
      { duration: 0.2, width: 0, height: 0, padding: 0 },
      ">"
    );
    tl.to(
      videoElement,
      {
        css: {
          gridColumn: "span 1 / span 1",
        },
      },
      ">"
    );
    videoButton.outerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-10 md:w-14 bg-green-600 p-2 rounded-full stroke-white h-10 md:h-14">
            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
    `;
    tl.to(image, {
      display: "block",
    });

    tl.to(title, {
      display: "flex",
    });
                tl.to(title, { duration: 0.2, autoAlpha: 1 }, ">");

    tl.to(video, { display: "none" });
    tl.to(nextButton, { display: "none" });
    tl.to(videoElement, {
      duration: 0.2,
      width: "100%",
      height: "100%",
      padding: "0.25rem",
    });

    tl.to(
      image,
      {
        autoAlpha: 1,
        duration: 0.2,
      },
      ">"
    );

    setTimeout(() => {
      video.innerHTML = "";
    }, 500);
    return tl;
  }

  function getNextVideoElement(currentVideoElement) {
    var allVideoElements = document.querySelectorAll(
      ".section-seance__container"
    );

    var currentIndex =
      Array.from(allVideoElements).indexOf(currentVideoElement);

    for (var i = currentIndex + 1; i < allVideoElements.length; i++) {
      if (allVideoElements[i].classList.contains("section-seance__container")) {
        return allVideoElements[i];
      }
    }

    return null;
  }

  async function preloadVideo(src, durationToPreloadInSeconds) {
    // Créer une requête pour récupérer les premiers segments de la vidéo
    // const rangeEnd = durationToPreloadInSeconds * 1024 * 1024; // Convertir la durée en mégaoctets
    //const headers = { Range: `bytes=0-${rangeEnd}` };
    //const res = await fetch(src, { headers });
    const res = await fetch(src);

    // Vérifier si la réponse est valide
    if (!res.ok) {
      throw new Error(
        `Erreur lors du chargement de la vidéo : ${res.status} ${res.statusText}`
      );
    }

    // Cloner la réponse pour éviter de lire le corps principal
    const resClone = res.clone();

    // Lire le contenu de la réponse clonée sous forme de blob
    const blob = await resClone.blob();

    // Créer l'URL pour les premiers segments de la vidéo
    return URL.createObjectURL(blob);
  }

  function loadVideo(videoElement) {
    const nextVideoElement = getNextVideoElement(videoElement);
    const isMobile = window.innerWidth < 768; // Détecte si l'appareil est un mobile
    const cols = isMobile ? "span 3 / span 3" : "span 4 / span 4";
        const videoButton = videoElement.querySelector("h3 svg");

    videoButton.outerHTML = `
        <span class="level__video-button relative top-0 left-0 m-0 w-12 h-12 md:w-24 md:h-24">
        </span>
    `;
    const image = videoElement.querySelector(".level__image");
    const videoContainer = videoElement.querySelector(".level__video"); // Définition de la variable video
    const play = videoElement.querySelector(".level__video-button");
    const title = videoElement.querySelector(".section__subheading");
    title.classList.add('title-active','animate-pulse');
    videoContainer.classList.add('w-full', 'h-auto', 'aspect-video');
    const tl = gsap.timeline();
        tl.set(videoElement, { duration: 0.2, autoAlpha: 0 });

    tl.set(image, { duration: 0.2, autoAlpha: 0 });
    tl.to(image, { display: "none" }, ">");
    tl.to(
      videoElement,
      {
        css: {
          gridColumn: cols,
        },
      },
      ">"
    );
                        tl.to(videoElement, { duration: 0.2, autoAlpha: 1 }, ">");

    const dataTag = videoElement.getAttribute("data-tag");
    const regex = /pack-(\d+)_niveau-(\d+)_seance-(\d+)/;
    const match = dataTag.match(regex);
    if (match) {
      const [_, pack, niveau, seance] = match;
      const queryString = `?src=${1}&pack=${pack}&niveau=${niveau}&seance=${seance}`;
      fetch(`https://jayfit.onrender.com/get-video-bis${queryString}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          const { accessGranted, seanceHTML } = data;
          if (accessGranted) {
            videoContainer.style.transitionDelay = "0s";
            const parser = new DOMParser();
            const doc = parser.parseFromString(seanceHTML, 'text/html');
            videoContainer.innerHTML = doc.documentElement.outerHTML;
            const iframe = videoContainer.querySelector('iframe');
            iframe.classList.add('w-full', 'h-auto', 'aspect-video');
                                    tl.set(iframe, { autoAlpha: 0 });

                        tl.to(videoContainer, { display: "block" }, ">");

            const nextButton = document.createElement("button");
            nextButton.classList.add(
              "hidden",
              "btn",
              "opacity-0",
              "md:w-fit",
              "items-center",
              "gap-2",

              "w-full",
              "md:text-2xl",
              "bg-black",
              "mx-auto",
              "my-6",
              "text-white",
              "font-black"
            );
            nextButton.innerHTML = `
            <span>JE VALIDE CETTE SÉANCE ET 
              <span class="text-[#E0DCD1]">
                JE PASSE À LA SUIVANTE
              </span>
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#000" class="w-8 shrink-0	bg-[#E0DCD1] p-2 rounded-full stroke-white aspect-square h-8">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"></path>
            </svg>`;
            nextButton.addEventListener("click", handleNext);
            videoElement.append(nextButton);
            tl.to(nextButton, { display: "flex" });
            tl.to(
              videoElement,
              {
                duration: 0.2,
                height: "100%",
                padding: "0.25rem",
                autoAlpha: 1,
              },
              ">"
            );

            tl.to(videoContainer, { duration: 0.2, autoAlpha: 1 }, ">");
            tl.to(image, { display: "none" }, ">");
            tl.to(title, { duration: 0.2, autoAlpha: 0 }, ">");
                                                tl.set(iframe, { duration: 0.2, autoAlpha: 1 });

            tl.to(nextButton, { delay: 1, duration: 0.2, autoAlpha: 1 }, ">");

          } else {
            videoContainer.innerHTML = ""
            tl.to(image, { display: "block" }, ">");
            tl.to(image, { duration: 0.2, autoAlpha: 1 }, ">");
            tl.to(videoContainer, { display: "none" }, ">");

            tl.to(nextButton, { display: "block" });
          }
        })
        .catch((error) => {
          console.error(error);
          videoContainer.innerHTML = ""
          tl.to(image, { display: "block" }, ">");
          tl.to(image, { duration: 0.2, autoAlpha: 1 }, ">");
          tl.to(videoContainer, { display: "none" }, ">");
        });
    } else {
      console.log("Format invalide");
    }

    function playVideo() {
      tl.to(image, { display: "none" }, ">");

      if (title) {
        tl.to(play, { duration: 0.2, autoAlpha: 0 });

        tl.to(title, { display: "none" }, ">");
      }
      if (play) {
        tl.to(play, { duration: 0.2, autoAlpha: 0 });

        tl.to(play, { display: "none" }, ">");
      }
/*
      if (video) {
        tl.to(video, { display: "block" }, ">");
        setTimeout(() => {
          video.play();
        }, 500);
      }*/
    }

    if (play) {
      play.addEventListener("click", playVideo);
    }

    async function handleNext() {
      /*
      checkVideo(videoElement);
      setTimeout(() => {
        loadVideo(nextVideoElement);
      }, 3000);
      */
      try {
        const customerID = String(__st.cid);

        const response = await fetch(
          "https://jayfit.onrender.com/validate-video",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              customerID: customerID,
              tagToRemove: dataTag,
            }),
          }
        );

        if (response.ok) {
          const data = await response.json();
          console.log(data.message);
          videoElement.classList.remove("seance-active");

          const nextVideoElement = getNextVideoElement(videoElement);
          nextVideoElement.classList.add("seance-active");
          checkVideo(videoElement);

          if (nextVideoElement) {
            setTimeout(() => {
              loadVideo(nextVideoElement);
            }, 3000);
          } else {
            console.log("Aucune vidéo suivante n'a été trouvée.");
          }
        } else {
          console.error("Erreur lors de la requête à l'API");
        }
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
      }
    }
  }

  const firstVideo = document.querySelector(
    ".section-seance__container.seance-active"
  );

  // Si un premier élément est trouvé, retirer la classe seance-active des autres éléments
  if (firstVideo) {
    const seanceContainers = document.querySelectorAll(
      ".section-seance__container.seance-active"
    );
    seanceContainers.forEach((container) => {
      if (container !== firstVideo) {
        container.classList.remove("seance-active");
      }
    });
    // Charger la première vidéo
    loadVideo(firstVideo);
  }

  function initHoverAware(selector) {
    document.querySelectorAll(selector).forEach((el) => {
      el.addEventListener("mouseenter", (event) => {
        const direction = getDirection(event, el);
        handleHover(event, el, direction);
      });
      let timer;
      el.addEventListener("mouseleave", (event) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          const direction = getDirection(event, el);
          handleHover(event, el, direction);
        }, 100);
      });
    });
  }

function handleHover(event, el, direction) {
  const hoverLayer = el.querySelector(".btn__hover-layer");
  const textEl = el.querySelector("p.navtext"); // cible le <p>
  const duration = 0.3;
  const delay = 0.1;
  const ease = Power2.easeInOut; // courbe compatible GSAP v2

  // évite les animations qui se chevauchent
  TweenLite.killTweensOf(hoverLayer);
  TweenLite.killTweensOf(textEl);

  const animateLayer = (fromTop, fromRight, toTop, toRight) => {
    if (event.type === "mouseenter") {
      TweenLite.fromTo(
        hoverLayer,
        duration,
        { top: fromTop, right: fromRight },
        { top: toTop, right: toRight, ease, delay }
      );

      // animer la couleur du texte vers noir
      TweenLite.to(textEl, duration, { color: "#000000", ease, delay });
    } else { // mouseleave
      TweenLite.to(hoverLayer, duration, { top: fromTop, right: fromRight, ease });

      // revenir au blanc
      TweenLite.to(textEl, duration, { color: "#ffffff", ease });
    }
  };

  switch (direction) {
    case 0:
      animateLayer("-100%", "0%", "0%", "0%");
      break;
    case 1:
      animateLayer("0%", "-100%", "0%", "0%");
      break;
    case 2:
      animateLayer("100%", "0%", "0%", "0%");
      break;
    case 3:
      animateLayer("0%", "100%", "0%", "0%");
      break;
  }
}


  function getDirection(event, el) {
    const coordinates = { x: event.pageX, y: event.pageY };
    const rect = el.getBoundingClientRect();
    const w = rect.width;
    const h = rect.height;

    const mouseX = coordinates.x - rect.left;
    const mouseY = coordinates.y - rect.top;

    const newX = (mouseX - w / 2) * (w > h ? h / w : 1);
    const newY = (mouseY - h / 2) * (h > w ? w / h : 1);

    let direction =
      Math.round((Math.atan2(newY, newX) * (180 / Math.PI) + 180) / 90 + 3) % 4;

    return direction;
  }

  initHoverAware(".btn--hover");

  document
    .querySelectorAll(".featured-collection__container .product-grid-item")
    .forEach((item) => {
      const tl = gsap.timeline({ paused: true });
      const parentContainer = item.parentElement;

      item.addEventListener("mouseenter", function () {
        const item_text = item.querySelector(".product-grid-item__info");
        const item_desc = item.querySelector(".product-grid-item__desc");
        const item_desc_bg = item.querySelector(".product-grid-item__desc-bg");

        const siblings = parentContainer.querySelectorAll(
          ".product-grid-item:not(:hover)"
        );
        const siblings_text = parentContainer.querySelectorAll(
          ".product-grid-item:not(:hover) .product-grid-item__info"
        );
        const siblings_item_desc = parentContainer.querySelectorAll(
          ".product-grid-item:not(:hover) .product-grid-item__desc"
        );
        const siblings_item_desc_bg = parentContainer.querySelectorAll(
          ".product-grid-item:not(:hover) .product-grid-item__desc-bg"
        );

        tl.to(item, {
          opacity: 1,
          scale: 1,
          duration: 0.1,
        });
        tl.to(
          item_desc_bg,
          {
            width: "100%",
          },
          ">"
        );
        tl.to(
          item_desc,
          {
            opacity: 1,
            duration: 0.1,
          },
          ">"
        );

        tl.to(
          item_text,
          {
            opacity: 1,
          },
          0
        );

        tl.to(
          siblings_item_desc,
          {
            opacity: 0,
            duration: 0.1,
          },
          0
        );

        tl.to(
          siblings_item_desc_bg,
          {
            width: 0,
            duration: 0.1,
          },
          ">"
        );

        tl.to(
          siblings,
          {
            opacity: 0.15,
            scale: 0.9,
            duration: 0.2,
          },
          ">"
        );

        tl.to(
          siblings_text,
          {
            opacity: 0,
          },
          ">"
        );

        tl.play();
      });
    });

  document
    .querySelectorAll(".featured-collection__container")
    .forEach((item) => {
      const tl = gsap.timeline({ paused: true });
      item.addEventListener("mouseleave", function () {
        const childrens = item.querySelectorAll(".product-grid-item");
        const childrens_text = item.querySelectorAll(
          ".product-grid-item__info"
        );
        const childrens_desc = item.querySelectorAll(
          ".product-grid-item__desc"
        );
        const childrens_desc_bg = item.querySelectorAll(
          ".product-grid-item__desc-bg"
        );
        console.log(childrens);
        console.log(childrens_text);

        tl.to(item.querySelectorAll(".product-grid-item"), {
          opacity: 1,
          scale: 1,
          duration: 0.1,
        });
        tl.to(
          childrens_text,
          {
            opacity: 1,
          },
          0
        );
        tl.to(
          childrens_desc,
          {
            opacity: 0,
            duration: 0.1,
          },
          ">"
        );

        tl.to(
          childrens_desc_bg,
          {
            width: 0,
            duration: 0.1,
          },
          ">"
        );
        tl.play();
      });
    });

  document.querySelectorAll(".classes-raw-wrapper").forEach((item) => {
    const wrapper = item;
    const dataId = wrapper.getAttribute("data-id");
    const hr = wrapper.querySelector("hr");

    const title = wrapper.querySelector(".classes-title");
    const columns = wrapper.querySelectorAll(".classes-column");
    const bg = wrapper.querySelector(".classes-bg");

    const image = wrapper
      .closest(".classes-content-wrapper")
      .querySelector(`.classes-left-column [data-id="${dataId}"]`);

    const image_mobile = wrapper.querySelector("img");

    const tl = gsap.timeline({ paused: true });
    tl.set(columns, { height: 0, opacity: 0 });
    tl.set(image, { x: "0em", opacity: 0, zIndex: 0 });
    tl.set(image_mobile, { height: 0, opacity: 0, zIndex: 0 });
    tl.set(hr, { width: 0 });
    tl.to(title, { duration: 0.2, x: "4%", opacity: 1 })
      .to(bg, { duration: 0.2, height: "100%", width: "100%" }, ">")
      .to(columns, { duration: 0.2, height: "100%" }, ">")
      .to(columns, { duration: 0.2, opacity: 1, stagger: 0.1 }, ">")
      .to(hr, { duration: 0.2, width: "100%" }, ">")
      .to(image, { duration: 0.2, x: "1em", opacity: 1, zIndex: 1 })

      .to(image_mobile, {
        duration: 0.2,
        height: "100%",
        opacity: 1,
        zIndex: 1,
      });

    item.addEventListener("mouseover", function () {
      tl.play();
    });
    item.addEventListener("mouseleave", function () {
      tl.reverse();
    });
    item.addEventListener("mouseout", function () {
      tl.reverse();
    });
  });

  document.querySelectorAll(".comparison-slider-container").forEach((item) => {
    const comparisonSlider = item;
    const sliderLeft = comparisonSlider.querySelector(".slider-left");
    const sliderBgLeft = sliderLeft.querySelector(".slider-bg-left");

    const handle = comparisonSlider.querySelector(".handle");
    const caption = comparisonSlider.querySelector(".slider-caption");
    const testimonial = comparisonSlider.querySelector(".slider-testimonial");

    const captionLeft = comparisonSlider.querySelector(".slider-caption-left");
    const captionRight = comparisonSlider.querySelector(
      ".slider-caption-right"
    );

    const comparisonSliderWidth = comparisonSlider.offsetWidth;
    sliderBgLeft.style.width = comparisonSliderWidth + "px";

    const comparisonSliderHeight = comparisonSlider.offsetHeight;

    const startPosition = (comparisonSliderWidth / 100) * 50;

    const tl = new TimelineMax({ delay: 1 });

    // set initial positioning

    // tween
    tl.set(caption, { autoAlpha: 0, yPercent: -100 }, 0);
    tl.set(testimonial, { autoAlpha: 0, yPercent: -100 }, 0);

    tl.to(
      sliderLeft,
      0.7,
      { width: startPosition, ease: Back.easeOut.config(1.7) },
      0
    );
    tl.to(handle, 0.7, { x: startPosition, ease: Back.easeOut.config(1.7) }, 0);
    tl.staggerTo(
      caption,
      0.7,
      { autoAlpha: 1, yPercent: 0, ease: Back.easeInOut.config(3) },
      -0.3,
      0
    );
    tl.staggerTo(
      testimonial,
      0.7,
      { autoAlpha: 1, yPercent: 0, ease: Back.easeInOut.config(3) },
      -0.3,
      ">"
    );

    // draggable
    Draggable.create(handle, {
      bounds: {
        minX: 0,
        minY: 0,
        maxX: comparisonSliderWidth,
        maxY: comparisonSliderHeight,
      },
      type: "x",
      edgeResistance: 1,
      throwProps: true,
      onDrag: onHandleDrag,
      onLockAxis: function () {
        var functionName = arguments.callee.name;
        console.log(functionName);
      },
    });

    function onHandleDrag() {
      console.log("drag", this);
      TweenMax.set(sliderLeft, { width: this.endX }, 0);

      // show/hide caption if you drag past the center of the container, towards left/right direction.
      if (this.endX >= this.maxX / 2 && this.getDirection() === "right") {
        showLeftCaption();
      }
      if (this.endX <= this.maxX / 2 && this.getDirection() === "left") {
        showRightCaption();
      }
    }

    function showLeftCaption() {
      TweenMax.to(captionLeft, 0.3, { autoAlpha: 1, yPercent: 0 }, 0);
      TweenMax.to(captionRight, 0.3, { autoAlpha: 0, yPercent: -100 }, 0);
    }

    function showRightCaption() {
      TweenMax.to(captionLeft, 0.3, { autoAlpha: 0, yPercent: -100 }, 0);
      TweenMax.to(captionRight, 0.3, { autoAlpha: 1, yPercent: 0 }, 0);
    }

    function showBothCaptions() {
      TweenMax.to(captionLeft, 0.3, { autoAlpha: 1, yPercent: 0 }, 0);
      TweenMax.to(captionRight, 0.3, { autoAlpha: 1, yPercent: 0 }, 0);
    }

    function slideHandleTo(_pos) {
      TweenMax.to(
        sliderLeft,
        0.7,
        { width: (comparisonSliderWidth / 100) * _pos, ease: Power2.easeOut },
        0
      );
      TweenMax.to(
        handle,
        0.7,
        { x: (comparisonSliderWidth / 100) * _pos, ease: Power2.easeOut },
        0
      );
    }
  });
})();
/*
$(document).ready(function () {
  $("#evoCalendar").evoCalendar({
    language: "fr", // km
    sidebarDisplayDefault: true,
    calendarEvents: [
       {
        id: '54',
        name: "Mensurations",
        date: "April/26/2024",
        type: "event",
        description: "taille:60,poitrine:50,bras:84,cuisse:90"
      }
    ],
  });
});
*/
